import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function Service_type(props) {
    const [formObj, setFormObj] = useState(FilterObj);
    const [serviceNameData, setServiceNameData] = React.useState([]);
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const { globalfilter, screen, reset } = props;
    const [filteredString, setValue] = useState("");
    const fetchServiceData = async (event) => {
        
        //const searchStr = event.target.value;
        //setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/services`;

        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                    //let obj = { "product": "All" };
                    let data = res.data;
                    // result.unshift(obj);
                    let result = data?.map((a, i) => {
                        return { id: a?.product, name: a?.product };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setServiceNameData(result);
                    console.log(serviceNameData);
                } else {
                    //ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    const handleChange = (event, newValue) => {
        //
        props.onChange(newValue);
        const filteredServiceType = {
            ...formObj,
            servicetype: newValue
        };
        setFormObj(filteredServiceType);
        setselectedvalue(newValue);
        setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
            ...Obj,
            servicetype: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        //
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                servicetype: filtervalue.servicetype
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.servicetype);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.servicetype);
            console.log('getcookievalue', formObj)
        }else{
            setFormObj({});
        }
       
    }
    React.useEffect(() => {
        
        if (reset>0)
        defaultValue(GlobalFilterSettingValue);
        
    }, [reset]);
    React.useEffect(() => {
        
        defaultValue(GlobalFilterSettingValue);
        fetchServiceData();
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj.servicetype || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={serviceNameData}
                getOptionLabel={(option) => option.name}
                //defaultValue={[top100Films[13]]}
                //inputValue={filteredString}
                onChange={(event, newValue) => handleChange(event, newValue)}
                // onChange={(event, newValue) => {
                //     //

                // }}

                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Report Type"
                        placeholder=""
                        onChange={fetchServiceData}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

